import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'PIs',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'pis',
                },
              },
              subqueries: {
                pis: {
                  filter: {
                    and: [
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projectOrgs',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        not: {
                          and: [
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '@': 'glExpensesInMtdcInLastThreeYears',
                                          },
                                        },
                                        3,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                            },
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdc',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'asf',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          asf: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'space',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          tdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'glExpenses',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          mtdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'glExpensesInMtdc',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                          mtdcAvg: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '@': 'glExpensesInMtdcInLastThreeYears',
                                        },
                                      },
                                      3,
                                    ],
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          projects: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'projectOrgs',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          totalSqft: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'space',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          tdcDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'space',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '??': [
                                            {
                                              '+': {
                                                '@': 'glExpenses',
                                              },
                                            },
                                            0,
                                          ],
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'space',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          mtdcDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'space',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '??': [
                                            {
                                              '+': {
                                                '@': 'glExpensesInMtdc',
                                              },
                                            },
                                            0,
                                          ],
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'space',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          utilization: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'space',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'space',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'sqft',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          mtdcAvgDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'space',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '??': [
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '@': 'glExpensesInMtdcInLastThreeYears',
                                                  },
                                                },
                                                3,
                                              ],
                                            },
                                            0,
                                          ],
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'space',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    space: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!space',
                        inherit: '=',
                      },
                      using: 'personSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@>': 'sqft',
                              },
                              {
                                '@>': 'utilization',
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                          utilization: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '+': {
                                        '@': 'weights',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'allowableWeights',
                                    },
                                  },
                                  {
                                    '+': {
                                      '@': 'weights',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                        },
                        allowableWeights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@': 'funcIdCat',
                              },
                              null,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    personSpace: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!personnel',
                        inherit: '-',
                      },
                      target: 'ent:!person_space:!entry',
                    },
                    projectOrgs: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    glExpensesInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                        expenseOrgShouldAnalyze: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@': 'organizationShouldAnalyze',
                          },
                          subqueries: {
                            organizationShouldAnalyze: {
                              ref: {
                                attr: 'attr:ent#!projects#!proj:!org',
                              },
                              target: 'ent:!org:!dept',
                              selection: {
                                '@.': '!should_analyze',
                              },
                            },
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                    glExpensesInMtdcInLastThreeYears: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    not: {
                      '=': [
                        {
                          '@': 'projectOrgs',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    not: {
                      and: [
                        {
                          '=': [
                            {
                              '??': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                            0,
                          ],
                        },
                        {
                          '=': [
                            {
                              '??': [
                                {
                                  '/': [
                                    {
                                      '+': {
                                        '@': 'glExpensesInMtdcInLastThreeYears',
                                      },
                                    },
                                    3,
                                  ],
                                },
                                0,
                              ],
                            },
                            0,
                          ],
                        },
                      ],
                    },
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdc',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdcDensity',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcDensityMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'asf',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'asfMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'effectiveRecovery',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'effectiveRecoveryMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              period: {
                '``': {
                  '@$': 'focusedRange',
                },
              },
              target: 'ent:!personnel:!employee',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpenses',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpensesInMtdc',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'glExpensesInMtdcInLastThreeYears',
                                    },
                                  },
                                  3,
                                ],
                              },
                              0,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projectOrgs',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '@': 'glExpenses',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '@': 'glExpensesInMtdc',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'space',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'space',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdcAvgDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '@': 'glExpensesInMtdcInLastThreeYears',
                                              },
                                            },
                                            3,
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          piHide: true,
                                          piRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                space: {
                  ref: {
                    attr: 'attr:ent#!person_space#!entry:!space',
                    inherit: '=',
                  },
                  using: 'personSpace',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@^': {
                                  '``': {
                                    '@$': 'spaceEntityId',
                                  },
                                },
                              },
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'spaceType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': [
                                  '!space_use',
                                  {
                                    ref: {
                                      entity: '!group',
                                    },
                                  },
                                ],
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  'ent:!space_use:!group',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!space:!room',
                  selection: {
                    '{}': {
                      asf: {
                        '*': [
                          {
                            '@>': 'sqft',
                          },
                          {
                            '@>': 'utilization',
                          },
                        ],
                      },
                      sqft: {
                        '@.': '!sqft',
                      },
                      utilization: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '+': {
                                    '@': 'weights',
                                  },
                                },
                                0,
                              ],
                            },
                            0,
                          ],
                          {
                            '/': [
                              {
                                '+': {
                                  '@': 'allowableWeights',
                                },
                              },
                              {
                                '+': {
                                  '@': 'weights',
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    weights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '??': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                    },
                    allowableWeights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '!=': [
                          {
                            '@': 'funcIdCat',
                          },
                          null,
                        ],
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '??': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                      subqueries: {
                        funcIdCat: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!func_space',
                          },
                          target: 'ent:!func_space:!func',
                          selection: {
                            '@.': [
                              '!func_idc',
                              {
                                ref: {
                                  entity: '!cat',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                glExpenses: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projectOrgs',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@': 'projectsResearchType',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
                personSpace: {
                  ref: {
                    attr: 'attr:ent#!person_space#!entry:!personnel',
                    inherit: '-',
                  },
                  target: 'ent:!person_space:!entry',
                },
                projectOrgs: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!proj',
                  },
                  using: 'projectPiAssignments',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '@.': '!id',
                  },
                },
                glExpensesInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projectOrgs',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '@': 'isInMtdc',
                      },
                    ],
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                    expenseOrgShouldAnalyze: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@': 'organizationShouldAnalyze',
                      },
                      subqueries: {
                        organizationShouldAnalyze: {
                          ref: {
                            attr: 'attr:ent#!projects#!proj:!org',
                          },
                          target: 'ent:!org:!dept',
                          selection: {
                            '@.': '!should_analyze',
                          },
                        },
                      },
                    },
                  },
                },
                projectPiAssignments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  target: 'ent:!proj_pis:!entry',
                },
                glExpensesInMtdcInLastThreeYears: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projectOrgs',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '@': 'isInMtdc',
                      },
                    ],
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2022',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!personnel#!employee:!code',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!personnel#!employee:!name',
                        },
                      },
                    },
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'spaceRecordId',
                        },
                        null,
                      ],
                    },
                    {
                      '[]': [
                        {
                          '{}': {
                            id: 'tdc',
                            direct: {
                              '{}': {
                                name: 'TDC Expense',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'tdcDensity',
                            direct: {
                              '{}': {
                                name: 'TDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdc',
                            direct: {
                              '{}': {
                                name: 'MTDC Expense',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcAvg',
                            direct: {
                              '{}': {
                                name: 'MTDC Average',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcAvgDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Average Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'asf',
                            direct: {
                              '{}': {
                                name: 'ASF',
                                type: 'INT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'projects',
                            direct: {
                              '{}': {
                                name: 'Projects',
                                type: 'INT',
                              },
                            },
                          },
                        },
                      ],
                    },
                  ],
                  {
                    '[]': [
                      {
                        '{}': {
                          id: 'asf',
                          direct: {
                            '{}': {
                              name: 'ASF',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'totalSqft',
                          direct: {
                            '{}': {
                              name: 'Total Area',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'utilization',
                          direct: {
                            '{}': {
                              name: 'Utilization',
                              type: 'PERCENT',
                            },
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcInLastThreeYears',
                                      ],
                                    },
                                  ],
                                },
                              },
                              3,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projectOrgs',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'totalSqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'utilization',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcAvgDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'records',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcInLastThreeYears',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  3,
                                ],
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projectOrgs',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        not: {
                          and: [
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '@': 'glExpensesInMtdcInLastThreeYears',
                                          },
                                        },
                                        3,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                            },
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdc',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'asf',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '{}': {
                      asf: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'space',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      tdc: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpenses',
                            },
                          },
                          0,
                        ],
                      },
                      mtdc: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdc',
                            },
                          },
                          0,
                        ],
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projectOrgs',
                            },
                          },
                          0,
                        ],
                      },
                      totalSqft: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'space',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      tdcDensity: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'glExpenses',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcDensity: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'glExpensesInMtdc',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      utilization: {
                        '??': [
                          {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          0,
                        ],
                      },
                      mtdcAvgDensity: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '@': 'glExpensesInMtdcInLastThreeYears',
                                          },
                                        },
                                        3,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcInLastThreeYears: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdcInLastThreeYears',
                            },
                          },
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    space: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!space',
                        inherit: '=',
                      },
                      using: 'personSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@>': 'sqft',
                              },
                              {
                                '@>': 'utilization',
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                          utilization: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '+': {
                                        '@': 'weights',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'allowableWeights',
                                    },
                                  },
                                  {
                                    '+': {
                                      '@': 'weights',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                        },
                        allowableWeights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@': 'funcIdCat',
                              },
                              null,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    personSpace: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!personnel',
                        inherit: '-',
                      },
                      target: 'ent:!person_space:!entry',
                    },
                    projectOrgs: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    glExpensesInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                        expenseOrgShouldAnalyze: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@': 'organizationShouldAnalyze',
                          },
                          subqueries: {
                            organizationShouldAnalyze: {
                              ref: {
                                attr: 'attr:ent#!projects#!proj:!org',
                              },
                              target: 'ent:!org:!dept',
                              selection: {
                                '@.': '!should_analyze',
                              },
                            },
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                    glExpensesInMtdcInLastThreeYears: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
  },
}
